import { z } from "zod";

export const roleSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z.string().min(1, "O nome é obrigatório"),
});

export type TRoleForm = z.infer<typeof roleSchema>;
